import React from "react";
import {useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import {Modal} from '@material-ui/core';

function PluginModal(props){

  // to take over scroll of the plugin
  useEffect(() => {
    let parentDiv = jQuery(jQuery('.topic-sidebar').closest('.interface-interface-skeleton__sidebar')[0] || jQuery('#usetopicData')[0]);
    if(props.open){
      parentDiv.addClass('topic-noscroll');
    } else{
      parentDiv.removeClass('topic-noscroll');
    }
  }, [props.open])

  return(
      <Modal
        open={props.open}
        onClose={props.onClose}
        container={() => {
          return jQuery('.topic-wp-plugin')[0]
        }}
        className="topic-plugin-modal"
        BackdropProps={{style: {position: 'absolute'}}}
      >
        <div className="topic-plugin-modal-container" onClick={props.onClose}>
          <div className="topic-plugin-modal-content" onClick={(e) => {e.stopPropagation()}}>
            <CloseIcon className="topic-plugin-modal-close" onClick={props.onClose}/>
            {props.children}
          </div>
        </div>
      </Modal>
  );

}

export default PluginModal;